import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueSignaturePad from 'vue-signature-pad';

Vue.use(BootstrapVue);
Vue.use(VueSignaturePad);
import router from './router'
import store from './store'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fonts/icons.js'
import './Services/ToastService'
import './Services/GlobalVariables'
import './Services/UsageTracker'
import DrawerLayout from 'vue-drawer-layout'
import Loading from 'vue-loading-overlay';
import {VueEditor} from "vue2-editor";
import VueQriously from 'vue-qriously'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueBarcodeScanner from 'vue-barcode-scanner'
import './registerServiceWorker'
let options = {
  sensitivity: 100, // default is 100
  requiredAttr: true, // default is false
  controlSequenceKeys: ['NumLock', 'Clear'], // default is null
  callbackAfterTimeout: true // default is false
}

// === Sentry (error tracking + tracing + logs) ===
// Order matters: Sentry.init() MUST run before new Vue().$mount('#app')
// (verified at runtime by SDK; warns if mounted already)
import * as Sentry from "@sentry/vue";

Sentry.init({
  // Vue 2: pass the Vue constructor (not an app instance — that's Vue 3)
  Vue,

  // DSN is a public key — safe to ship in JS bundle, but use env var for
  // environment-specific overrides (staging vs prod).
  dsn: process.env.VUE_APP_SENTRY_DSN_KAZANG_BACKOFFICE_FRONTEND || "",

  // Environment / release tagging
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "production",
  release: process.env.VUE_APP_SENTRY_RELEASE || "kazangbackoffice-frontend@1.0.0+sentry-v1",

  // Tracing (5% of transactions — fleet default for low-traffic internal app)
  integrations: [
    Sentry.browserTracingIntegration({ router }),
  ],
  tracesSampleRate: Number(process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE || 0.05),
  // Real production API domains read from src/Services/GlobalVariables.js (lines 18–68):
  //   - lna.pos.co.zm       → SynergyApi (usage tracker), KazangPaymentGateway, PettyCashApi, TicketApp
  //   - overflow.pos.co.zm  → OnlineSalesServer, loyalty_service, FranchiseSpringServer, Franchise_OnlineServer, SubscriptionManager
  //   - chrilantech.com     → LytSoftPosOnline (laravel), regmac
  // Excluded (per §8 of manual): placeholder IPs in comments, dev URLs.
  //
  // Gated on VUE_APP_SENTRY_TRACING_ENABLED: when unset / 'false', no sentry-trace
  // or baggage headers are sent on outgoing requests, so no CORS preflight is
  // triggered for them. This is the safe default until the backend CORS config
  // is updated to allow 'sentry-trace' and 'baggage' in Access-Control-Allow-Headers.
  // Set 'true' in production env after backend CORS update lands.
  tracePropagationTargets: process.env.VUE_APP_SENTRY_TRACING_ENABLED === 'true'
    ? [
        "localhost",
        /^https:\/\/lna\.pos\.co\.zm\//,
        /^https:\/\/overflow\.pos\.co\.zm\//,
        /^https:\/\/chrilantech\.com\//,
      ]
    : [],

  // Logs (v9 supports this, same as v8)
  enableLogs: true,

  // PII controls — fleet convention (replaces sendDefaultPii: true which was wrong)
  dataCollection: {
    userInfo: false,
    httpBodies: [],
  },

  // Strip sensitive fields from event extras (mirror of Spring Boot SentryConfig)
  beforeSend(event) {
    if (event.extra) {
      delete event.extra.password;
      delete event.extra.apiKey;
      delete event.extra.authorization;
    }
    return event;
  },
});
// === End Sentry ===

Vue.use(VueQriously);
Vue.use(VueBarcodeScanner, options);
Vue.component('vue-editor',VueEditor)

Vue.component('v-select', vSelect)
Vue.component('loading', Loading);
Vue.use(DrawerLayout);
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')

try {
  const { initTabGuardLeader } = require('./Services/tabGuardLeader');
  initTabGuardLeader();
} catch (e) {
  // Best-effort initialization; safe to ignore in non-browser contexts
}
